<template>
  <el-dialog
    :title="employee.id?'编辑人员':'添加人员'"
    :visible.sync="show"
    width="30%"
    @close="onClose"
    :close-on-click-modal="false"
  >
    <div class="column-view">
      <el-form label-position="right" label-width="100px">
        <el-form-item label="人员姓名" required>
          <el-input placeholder="请输入人员姓名" v-model="employee.name"></el-input>
        </el-form-item>
        <el-form-item label="性别" required>
          <el-select v-model="employee.gender" placeholder="请选择性别" @change="onSelectGenderChange" style="width: 100%">
            <el-option
              v-for="item in gender"
              :key="item.id"
              :label="item.label"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="职务说明">
          <el-input type="textarea" v-model="employee.note"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="()=>{this.show=false}">取 消</el-button>
      <el-button type="primary" @click="onSaveClick()" >保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import selectJobGrade from "@/views/setting/jobGradeManagement/components/selectJobGrade";
export default {
  name: "createEditPartmentDialog",
  //是否是编辑 、 类型 1：局级  2：部门级
  components: {selectJobGrade},
  data() {
    return {
      show: false,
      gender:[
        {
          id:1,
          label:'男'
        },
        {
          id:2,
          label:'女'
        },
      ],
      employee:{
        name:'',
        id:'',
        gender:'',
        note:'',
      }
    }
  },
  methods: {
    onSelectGenderChange(e){
      this.employee.gender=e
    },

    onSaveClick(){
      if(!this.employee.name){
        return this.$commonUtils.showMessage('请输入人员名称','error')
      }
      if(!this.employee.gender){
        return this.$commonUtils.showMessage('请选择性别','error')
      }
      let request_data={
        name:this.employee.name,
        gender:this.employee.gender,
        note:this.employee.note||''
      }

      if(this.employee.id){
        request_data['id']=this.employee.id
      }

      this.$prompt('确认保存当前人员信息', '保存人员信息', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        type: 'warning',
        showInput: false,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '保存中...'
            this.http.api(this.employee.id?'editEmployee':'addEmployee', request_data).then(res => {
              if (res.status) {
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '保存'
                done()
                this.show=false;
                this.$commonUtils.showMessage('操作成功','success')
                this.$emit('onRefreshData')
              } else {
                this.$commonUtils.showMessage((res.message) ? (res.message) : '操作失败,请稍候再试', 'error')
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '保存'
              }
            }).catch(() => {})
          } else {
            done()
          }
        }
      }).then(res => {
      }).catch(error => {
      })


    },


    onClose() {
      this.employee={
        name:'',
        id:'',
        gender:'',
        note:'',
      }

    },

    setData(data) {
      this.show = true;
      this.employee=data;
    },

    showDialog() {
      this.show = true;
    },
  }
}
</script>

<style scoped>

</style>
